import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AntLiquidationService {

  constructor(private http: HttpClient) {}

  getPartes(cuit, liquidacion, pageNumber, fechaDesde, fechaHasta, VIEWED, new_type, new_status): Observable<any[]> {
    const values = {
      size: "10",
      pageNumber,
      sortProp: '',
      sortOrder: 'desc',
      estado: new_status,
      type: new_type,
      filter: '',
      liquidacion,
      fechaDesde: '',
      fechaHasta: '',
      procurador: ''
    };

    if (fechaDesde) { values['fechaDesde'] = fechaDesde; }
    if (fechaHasta) { values['fechaHasta'] = fechaHasta; }

    const httpParams = new HttpParams({
      fromObject: values
    });

    return this.http.get<any[]>(`${environment.BACKEND}parteNovedad/consultaGeneral`, {
      params: httpParams
    });
  }

  updateState(id): Observable<any[]> {
    return this.http.put<any[]>(`${environment.BACKEND}parteNovedad/updateState/${id}`, {});
  }

  dowloadPDF(nroPartes): Observable<any[]> {
    const listaNroPartes = nroPartes.map(e => e.ID).join(',');
    const arrayPartes = listaNroPartes.split(",");

    const values = {
      listId: arrayPartes
    };


    return this.http.post<any[]>(`${environment.BACKEND}parteNovedad/downloadPdf`, values);
  }



  datosLiq(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this.http.get(`${environment.BACKEND}liquidacion/psrm/getDataLiq`, {
      params: httpParams
    });
  }


  datosLiqHist(values) {
    const httpParams = new HttpParams({
      fromObject: values
    });

    return this.http.get(`${environment.BACKEND}liquidacion/psrm/histEtapaLiq`, {
      params: httpParams
    });
  }

  getAllStage(ETAPA_ID) {
  

    return this.http.get(`${environment.BACKEND}liquidacion/psrm/getAllStages?ETAPA_ID=${ETAPA_ID}`);
  }

  getBajas() {
  

    return this.http.get(`${environment.BACKEND}liquidacion/psrm/getStagesDown`);
  }

  deleteEtapa(values): any {
    return this.http.put<any>(`${environment.BACKEND}liquidacion/psrm/eliminarEtapa`, values);
  }


  submitStage(values) {
    return this.http.post(
      `${environment.BACKEND}liquidacion/informar/registrarEtapa`,
      values
    );
  }


}
